namespace TabAurous.Sales {
    export interface SalesItemsRow {
        TransItemId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        Hallmark?: number;
        RefNo?: string;
        ItemTypeId?: number;
        ProductId?: number;
        AttributeId?: number;
        Studded?: number;
        Pieces?: number;
        Parts?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CostMethodId?: number;
        SalesCostMethodId?: Common.CostMethod;
        PurchaseCostMethodId?: Common.CostMethod;
        CalcOnId?: number;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        Discount?: number;
        DiscountPer?: number;
        GrossAmount?: number;
        GrossAmountPercent?: number;
        RefTransItemId?: number;
        RefTransId?: number;
        ImageName?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        AckStatus?: number;
        StockAllocation?: boolean;
        DeliveryDate?: string;
        CompanyId?: number;
        BagStatus?: string;
        WstPer?: number;
        WstWt?: number;
        Purity?: number;
        PureWeight?: number;
        ServerDate?: string;
        Remarks?: string;
        IsDisabled?: boolean;
        IsRepairProcess?: boolean;
        RefOrderId?: number;
        RefOrderItemId?: number;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        FancyCharges?: number;
        OtherCharges?: number;
        MFAmount?: number;
        MF?: number;
        LedgerName?: string;
        DeptName?: string;
        ProductCode?: string;
        ProductName?: string;
        TaxCode?: string;
        HSN?: string;
        MetalId?: number;
        HasBom?: boolean;
        DesignId?: number;
        DesignCode?: string;
        BOMDetails?: SalesItemsBOMRow[];
        LaborDetails?: SalesLaborRow[];
        ItemType?: string;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        SuperTypeCode?: string;
        CollectionId?: number;
        MetalColorId?: number;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        CategoryCode?: string;
        Attribute?: string;
        CalcUnitId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        Rate?: number;
        KaratId?: number;
        ProductSizeId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        ProductSizeCode?: string;
        StampCode?: string;
        BrandName?: string;
        CollectionName?: string;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Lab?: string;
        VoucherNo?: string;
        TransDate?: string;
        HUID?: string;
        StampId?: number;
        ExportPieces?: number;
        CompanyCode?: string;
        StoneRate?: number;
        OtherRate?: number;
        FinancialYearId?: number;
        BillNo?: string;
        BillDate?: string;
        IsPosted?: boolean;
        Quarter1Amount?: number;
        Quarter1Pieces?: number;
        Quarter2Amount?: number;
        Quarter2Pieces?: number;
        Quarter3Amount?: number;
        Quarter3Pieces?: number;
        Quarter4Amount?: number;
        Quarter4Pieces?: number;
        PriceRange1?: number;
        PriceRange2?: number;
        PriceRange3?: number;
        PriceRange4?: number;
        PriceRange5?: number;
        Week?: string;
        Monday?: number;
        Tuesday?: number;
        Wednesday?: number;
        Thursday?: number;
        Friday?: number;
        Saturday?: number;
        Month?: string;
        Week1Pieces?: number;
        Week2Pieces?: number;
        Week3Pieces?: number;
        Week4Pieces?: number;
        Week1Sales?: number;
        Week2Sales?: number;
        Week3Sales?: number;
        Week4Sales?: number;
        Quarter?: string;
        Month1?: number;
        Month2?: number;
        Month3?: number;
    }

    export namespace SalesItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'ProductName';
        export const localTextPrefix = 'Sales.SalesItems';
        export const deletePermission = 'Sales:Invoice:Delete';
        export const insertPermission = 'Sales:Invoice:Add';
        export const readPermission = '*';
        export const updatePermission = 'Sales:Invoice:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            PartyId = "PartyId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            Hallmark = "Hallmark",
            RefNo = "RefNo",
            ItemTypeId = "ItemTypeId",
            ProductId = "ProductId",
            AttributeId = "AttributeId",
            Studded = "Studded",
            Pieces = "Pieces",
            Parts = "Parts",
            Weight = "Weight",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            CostMethodId = "CostMethodId",
            SalesCostMethodId = "SalesCostMethodId",
            PurchaseCostMethodId = "PurchaseCostMethodId",
            CalcOnId = "CalcOnId",
            UnitRate = "UnitRate",
            UnitLabour = "UnitLabour",
            UnitCost = "UnitCost",
            NetAmount = "NetAmount",
            Discount = "Discount",
            DiscountPer = "DiscountPer",
            GrossAmount = "GrossAmount",
            GrossAmountPercent = "GrossAmountPercent",
            RefTransItemId = "RefTransItemId",
            RefTransId = "RefTransId",
            ImageName = "ImageName",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            AckStatus = "AckStatus",
            StockAllocation = "StockAllocation",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            BagStatus = "BagStatus",
            WstPer = "WstPer",
            WstWt = "WstWt",
            Purity = "Purity",
            PureWeight = "PureWeight",
            ServerDate = "ServerDate",
            Remarks = "Remarks",
            IsDisabled = "IsDisabled",
            IsRepairProcess = "IsRepairProcess",
            RefOrderId = "RefOrderId",
            RefOrderItemId = "RefOrderItemId",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            FancyCharges = "FancyCharges",
            OtherCharges = "OtherCharges",
            MFAmount = "MFAmount",
            MF = "MF",
            LedgerName = "LedgerName",
            DeptName = "DeptName",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            TaxCode = "TaxCode",
            HSN = "HSN",
            MetalId = "MetalId",
            HasBom = "HasBom",
            DesignId = "DesignId",
            DesignCode = "DesignCode",
            BOMDetails = "BOMDetails",
            LaborDetails = "LaborDetails",
            ItemType = "ItemType",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            SuperTypeCode = "SuperTypeCode",
            CollectionId = "CollectionId",
            MetalColorId = "MetalColorId",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            CategoryCode = "CategoryCode",
            Attribute = "Attribute",
            CalcUnitId = "CalcUnitId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            Rate = "Rate",
            KaratId = "KaratId",
            ProductSizeId = "ProductSizeId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            ProductSizeCode = "ProductSizeCode",
            StampCode = "StampCode",
            BrandName = "BrandName",
            CollectionName = "CollectionName",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Lab = "Lab",
            VoucherNo = "VoucherNo",
            TransDate = "TransDate",
            HUID = "HUID",
            StampId = "StampId",
            ExportPieces = "ExportPieces",
            CompanyCode = "CompanyCode",
            StoneRate = "StoneRate",
            OtherRate = "OtherRate",
            FinancialYearId = "FinancialYearId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            IsPosted = "IsPosted",
            Quarter1Amount = "Quarter1Amount",
            Quarter1Pieces = "Quarter1Pieces",
            Quarter2Amount = "Quarter2Amount",
            Quarter2Pieces = "Quarter2Pieces",
            Quarter3Amount = "Quarter3Amount",
            Quarter3Pieces = "Quarter3Pieces",
            Quarter4Amount = "Quarter4Amount",
            Quarter4Pieces = "Quarter4Pieces",
            PriceRange1 = "PriceRange1",
            PriceRange2 = "PriceRange2",
            PriceRange3 = "PriceRange3",
            PriceRange4 = "PriceRange4",
            PriceRange5 = "PriceRange5",
            Week = "Week",
            Monday = "Monday",
            Tuesday = "Tuesday",
            Wednesday = "Wednesday",
            Thursday = "Thursday",
            Friday = "Friday",
            Saturday = "Saturday",
            Month = "Month",
            Week1Pieces = "Week1Pieces",
            Week2Pieces = "Week2Pieces",
            Week3Pieces = "Week3Pieces",
            Week4Pieces = "Week4Pieces",
            Week1Sales = "Week1Sales",
            Week2Sales = "Week2Sales",
            Week3Sales = "Week3Sales",
            Week4Sales = "Week4Sales",
            Quarter = "Quarter",
            Month1 = "Month1",
            Month2 = "Month2",
            Month3 = "Month3"
        }
    }
}
